
const animateFormLabel = () => {
  const forms = document.querySelectorAll('.form');
  if (forms.length !== 0) {
    forms.forEach((form) => {
      const fields = form.querySelectorAll('.form__field');
      if (fields.length > 0) {
        fields.forEach((field) => {
          if (field.value.length > 0) {
            field.classList.add('form__field--active');
          }

          field.addEventListener('input', (evt) => {
            if (evt.currentTarget.value.length) {
              evt.currentTarget.classList.add('form__field--active')
            } else {
              evt.currentTarget.classList.remove('form__field--active')
            }
          });
        });
      }
      form.classList.add('form--active');
    });
  }
}

export default animateFormLabel;
